import { Component, Input, OnChanges } from '@angular/core';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';
import { FadingSpanComponent } from '../fading-span/fading-span.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-average-sun',
    templateUrl: './average-sun.component.html',
    styleUrls: ['./average-sun.component.scss'],
    imports: [FadingSpanComponent, TranslateModule],
})
export class AverageSunComponent extends AbstractComponentMobile implements OnChanges {
    public override tag = '[AverageSunComponent]';

    @Input()
    public sunsValue = 0;

    @Input()
    public averageValue? = 0;

    @Input()
    public onlySuns = false;

    public sunsPercent: Array<number> = Array(0);

    public ngOnChanges() {
        this.sunsPercent = Array(0);
        for (let i = 0; i < Math.min(Math.floor(this.sunsValue), 4); i++) {
            this.sunsPercent.push(100);
        }
        this.sunsPercent.push((100 * Math.round(2 * (this.sunsValue - this.sunsPercent.length))) / 2);

        const sunsPercentLength = this.sunsPercent.length;
        for (let i = 0; i < 5 - sunsPercentLength; i++) {
            this.sunsPercent.push(0);
        }
    }
}
